const getRecordTaggingFieldKey = ({
  fieldType,
  fieldName,
}: {
  fieldType: BonusRecordTagging.FieldType;
  fieldName: string;
}) => `${fieldType}-${fieldName}`;

export default getRecordTaggingFieldKey;
